import React from 'react';
import moment from 'moment';
import get from 'lodash/get';

const TimeFieldInList = ({ record, source }) => {
  const value = get(record, source);

  const formatTime = (value) => {
    return moment(value, 'HH:mm:ss').format('h:mm a');
  };

  return <div>{formatTime(value)}</div>;
};

export default TimeFieldInList;
